import React from "react";
import { injectIntl } from "react-intl";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import { SubdirectoryArrowRight } from "components/Icons";
import Table from "components/Table";
import Select from "components/Select";
import { orderLinesColumns } from "./columns";

interface IProps {
  intl: any;
  isLoading: boolean;
  loadData: () => void;
  onActionSelect: (ids, selectedOption) => void;
  data: any[];
}

interface IState {
  selectedOption: string;
  checkedRows: any;
}

class OrderLines extends React.PureComponent<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: "",
      checkedRows: {}
    };
  }

  public componentDidMount() {
    this.props.loadData();
  }

  private handleSelect = selectedOption => {
    const ids = _(this.state.checkedRows)
      .keys()
      .map(_.toNumber)
      .value();

    this.props.onActionSelect(ids, selectedOption);
    this.setState({ selectedOption });
  };

  public render() {
    const { data, isLoading, intl } = this.props;
    const { selectedOption, checkedRows } = this.state;

    return (
      <div>
        <div className="top-buttons">
          <div className="dropdown-button">
            <label>
              <SubdirectoryArrowRight />
              <FormattedMessage id="SELECTED" />
            </label>
            <Select
              id="mark-fully-delivered"
              options={[
                {
                  value: "delivered",
                  label: intl.formatMessage({ id: "MARK_FULLY_DELIVERED" })
                }
              ]}
              onChange={this.handleSelect}
              selectedOption={selectedOption}
            />
          </div>
        </div>
        <Table
          columns={orderLinesColumns}
          dataSource={data}
          isLoading={isLoading}
          onRowSelect={checkedRows => this.setState({ checkedRows })}
          checkedRows={checkedRows}
        />
      </div>
    );
  }
}

export default injectIntl(OrderLines);
